import { Drawer } from '@framework/ui';
import { Tooltip } from 'antd';
import React, { useState } from 'react';
import { LastLoginDrawerContent } from './LastLoginDrawerContent';
import { LastLoginText } from './LastLoginText';
import { useLastLoginHistory } from './useLastLoginHistory';

export interface ILastLoginDrawerButtonProps {
  /** Quando il pulsante è mostrato nella pagina di login */
  isLink?: boolean;
}

/**
 * Pulsante che mostra l'ultimo accesso dell'utente e se cliccato mostra un Drawer con gli ultimi 10 accessi
 */
export function LastLoginDrawerButton(props: ILastLoginDrawerButtonProps) {
  const { history, isLoading, error } = useLastLoginHistory();
  const [isOpen, setIsOpen] = useState(false);
  const linkRef = React.useRef<HTMLAnchorElement>(null);

  return (
    <>
      <Tooltip title="Mostra elenco accessi" placement="left">
        <a ref={linkRef} href="#" onClick={() => setIsOpen(true)}>
          <LastLoginText
            isLink={props.isLink}
            historyData={{ history, isLoading, error }}
          />
        </a>
      </Tooltip>

      <Drawer
        open={isOpen}
        onClose={() => {
          setIsOpen(false);
          linkRef.current?.focus();
        }}
        maskClosable={false}
        title="Elenco ultimi 10 accessi"
        placement="right"
        size="large"
      >
        <LastLoginDrawerContent historyData={{ history, isLoading, error }} />
      </Drawer>
    </>
  );
}
